/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { EditButton, List, TextField, ReferenceField } from 'react-admin'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import ListTitle from '../../components/ListTitle'
import Datagrid from '../../components/Datagrid/Datagrid'
import Filter from '../../components/Filter/FilterComponents'

const styles = {
    myHeader: {
        '&&:before': {
            content: '" ⇅ "',
        },
    },
    header: {
        display: 'none',
    },
}
const useStyles = makeStyles(styles)

export default function CityList(props) {
    const classes = useStyles(props)
    const { quickSearch } = props
    return (
        <List
            sort={{ field: 'code', order: 'ASC' }}
            filters={<Filter {...props} />}
            {...props}
        >
            <>
                <ListTitle label="City" />
                <Datagrid {...props}>
                    <TextField
                        label="Code"
                        headerClassName={classes.myHeader}
                        source="code"
                    />
                    <TextField
                        label="Description"
                        headerClassName={classes.myHeader}
                        source="description"
                    />
                    <ReferenceField
                        source="province_id"
                        reference="PY_ProvinceTAB"
                    >
                        <TextField
                            label="Province"
                            headerClassName={classes.myHeader}
                            source="description"
                        />
                    </ReferenceField>
                    {quickSearch ? (
                        <EditButton
                            headerClassName={classes.header}
                            basePath="/PY_CityTAB"
                        />
                    ) : (
                        <EditButton basePath="/PY_CityTAB" />
                    )}
                </Datagrid>
            </>
        </List>
    )
}

CityList.defaultProps = {
    quickSearch: false,
}
CityList.propTypes = {
    quickSearch: PropTypes.bool,
}
